import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import HeaderActions from "../../../../components/ModuleCommon/StickyHeader/HeaderActions";

const CreatePO = () => {
  const navigate = useNavigate();
  const token = Cookies.get("authToken"); // 🔹 Replace with your actual token
  const officeCode = Cookies.get("officeCode"); // 🔹 Replace with your actual token

  // ─────────────────────────────────────────────────────────────────────────────
  // SETUP INITIAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [purchaseOrder, setPurchaseOrder] = useState({
    orderNumber: "",
    orderType: "PO",
    orderDatetime: "",
    expectedDeliveryDatetime: "",
    supplierCode: "",
    buyerCode: "",
    shipFromLocation: "",
    shipToLocation: "",
    carrierCode: "PostOffice", // TODO: Delete default code
    orderTotalAmount: "",
    // officeCode: officeCode,
  });

  const button = [
    { label: "Send Order", type: "primary" },
    
];

  // ─────────────────────────────────────────────────────────────────────────────
  // SEARCH QUERY FOR ITEMS
  // ─────────────────────────────────────────────────────────────────────────────

  const [item, setItem] = useState("");
  // const [itemResults, setItemResults] = useState([]);
  const [selectedItem, setSelectedItem] = useState({
    sku: "",
    reorderLevel: "",
    costPrice: "",
    sellingPrice: "",
  });

  /******************* Handle 1 item at a time *****************************/
  // const fetchItemResults = async (searchQuery) => {
  //   if (!searchQuery) return; // Prevent API calls when empty

  //   const response = await fetch(
  //     `http://localhost:8080/api/products/search?query=${searchQuery}&officeCode=${officeCode}&page=0&size=10`,
  //     {
  //       headers: { Authorization: `Bearer ${token}` },
  //     }
  //   );
  //   const data = await response.json();
  //   console.log(data);
  //   setItemResults(data.content); // Page object returns `content`
  // };

  // const handleInputItemChange = (e) => {
  //   const newQuery = e.target.value;
  //   setItem(newQuery);

  //   if (!newQuery.trim()) {
  //     setItemResults([]); // Clear results when input is empty
  //     return;
  //   }

  //   clearTimeout(window.searchTimeout);
  //   window.searchTimeout = setTimeout(() => {
  //     fetchItemResults(newQuery);
  //   }, 300); // ✅ 300ms Debounce
  // };

  // const handleSelectProduct = (product) => {
  //   setItem(product.name); // ✅ Set the input field to the selected product's name
  //   setItemResults([]); // ✅ Clear search results after selection

  //   // ✅ Optionally, store the selected product SKU in purchaseOrder
  //   setPurchaseOrder((prev) => ({
  //     ...prev,
  //     selectedProductId: product.id, // Store the product ID (or SKU)
  //   }));

  //   setSelectedItem ({
  //     sku: product.sku || "N/A",
  //     reorderLevel: product.reorderLevel || "N/A",
  //     costPrice: product.costPrice || "N/A",
  //     sellingPrice: product.sellingPrice || "N/A",
  //   });
  // };

  /************************ Handle Several items ***************************/
  // ✅ State to store multiple selected items
  const [items, setItems] = useState([]);
  const [itemResults, setItemResults] = useState([]);
  // ✅ Fetch items from API (unchanged)
  const fetchItemResults = async (searchQuery) => {
    if (!searchQuery) return; // Prevent API calls when empty

    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/products/simple-search?query=${searchQuery}&&page=0&size=10`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Office-Code": officeCode,
        },
      }
    );
    const data = await response.json();
    console.log(data);
    setItemResults(data.content); // Page object returns `content`
  };

  // ✅ Handle input change for a specific item index
  const handleInputItemChange = (e, index) => {
    const newItems = [...items];
    newItems[index].name = e.target.value;
    setItems(newItems);

    if (!e.target.value.trim()) {
      setItemResults([]); // Clear results when input is empty
      return;
    }

    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => {
      fetchItemResults(e.target.value);
    }, 300); // ✅ 300ms Debounce
  };

  // ✅ Handle selecting a product from search results
  const handleSelectProduct = (product, index) => {
    const newItems = [...items];
    newItems[index] = {
      name: product.name,
      sku: product.sku || "N/A",
      reorderLevel: product.reorderLevel || "N/A",
      costPrice: product.costPrice || "N/A",
      sellingPrice: product.sellingPrice || "N/A",
    };
    setItems(newItems);

    // ✅ Clear search results after selection
    setItemResults([]);
  };

  // ✅ Add new empty item fields
  const handleAddItem = () => {
    setItems([
      ...items,
      {
        name: "",
        sku: "",
        reorderLevel: "",
        costPrice: "",
        sellingPrice: "",
        itemQuantity: 1,
      },
    ]);
  };

  // ✅ Remove an item
  const handleRemoveItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 2) SEARCH QUERY FOR CARRIERS
  // ─────────────────────────────────────────────────────────────────────────────
  // const [carriers, setCarriers] = useState("");
  // const [carrierResults, setCarrierResults] = useState([]);

  // const fetchCarrierResults = async (searchQuery) => {
  //   if (!searchQuery) {
  //     setCarrierResults([]);
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `http://localhost:8080/api/carriers/search?query=${searchQuery}&officeCode=${officeCode}&page=0&size=10`,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //     if (!response.ok) throw new Error("Failed to fetch carriers");

  //     const data = await response.json();
  //     setCarrierResults(data.content);
  //   } catch (error) {
  //     console.error("Error fetching carriers:", error);
  //     setCarrierResults([]);
  //   }
  // };

  // const handleInputCarrierChange = (e) => {
  //   const newQuery = e.target.value;
  //   setCarriers(newQuery); // ✅ Correctly store input value

  //   if (!newQuery.trim()) {
  //     setCarrierResults([]); // ✅ Clear results when input is empty
  //     return;
  //   }

  //   clearTimeout(window.searchTimeout);
  //   window.searchTimeout = setTimeout(() => {
  //     fetchCarrierResults(newQuery);
  //   }, 300);
  // };

  // const handleSelectCarrier = (carrier) => {
  //   setCarriers(carrier.name); // ✅ Set input field to selected carrier name
  //   setCarrierResults([]); // ✅ Clear results

  //   setPurchaseOrder((prev) => ({
  //     ...prev,
  //     carrierCode: carrier.name, // ✅ Store carrier selection in order
  //   }));
  // };

  // ─────────────────────────────────────────────────────────────────────────────
  // SEARCH QUERY FOR BUYERS
  // ─────────────────────────────────────────────────────────────────────────────
  const [buyer, setBuyers] = useState("");
  const [buyerResults, setBuyerResults] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState({
    contactName: "",
    email: "",
    phone: "",
    address: "",
  });

  const fetchBuyerResults = async (searchQuery) => {
    if (!searchQuery) {
      setBuyerResults([]);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/buyers/search?query=${searchQuery}&page=0&size=10`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Office-Code": officeCode,
          },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch carriers");

      const data = await response.json();
      // console.log(data);
      setBuyerResults(data.content);
    } catch (error) {
      console.error("Error fetching carriers:", error);
      setBuyerResults([]);
    }
  };

  const handleInputBuyerChange = (e) => {
    const newQuery = e.target.value;
    setBuyers(newQuery); // ✅ Correctly store input value

    if (!newQuery.trim()) {
      setBuyerResults([]); // ✅ Clear results when input is empty
      return;
    }

    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => {
      fetchBuyerResults(newQuery);
    }, 300);
  };

  const handleSelectBuyer = (buyer) => {
    setBuyers(buyer.name); // ✅ Set input field to selected carrier name
    setBuyerResults([]); // ✅ Clear results

    setPurchaseOrder((prev) => ({
      ...prev,
      buyerCode: buyer.name, // ✅ Store carrier selection in order
    }));

    // ✅ Store full details in `selectedBuyer` for display
    setSelectedBuyer({
      contactName: buyer.contactName || "N/A",
      email: buyer.email || "N/A",
      phone: buyer.phone || "N/A",
      address: buyer.address || "N/A",
    });
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // SEARCH QUERY FOR SUPPLIERS/SELLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const [supplier, setSupplier] = useState("");
  const [supplierResult, setSupplierResults] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState({
    leadTime: "",
    paymentTerm: "",
  });

  const fetchSupplierResults = async (searchQuery) => {
    if (!searchQuery) {
      setSupplierResults([]);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/suppliers/search?query=${searchQuery}&page=0&size=10`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Office-Code": officeCode,
          },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch carriers");

      const data = await response.json();
      setSupplierResults(data.content);
    } catch (error) {
      console.error("Error fetching carriers:", error);
      setSupplierResults([]);
    }
  };

  const handleInputSupplierChange = (e) => {
    const newQuery = e.target.value;
    setSupplier(newQuery); // ✅ Correctly store input value

    if (!newQuery.trim()) {
      setSupplierResults([]); // ✅ Clear results when input is empty
      return;
    }

    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => {
      fetchSupplierResults(newQuery);
    }, 300);
  };

  const handleSelectSupplier = (supplier) => {
    setSupplier(supplier.name); // ✅ Set input field to selected carrier name
    setSupplierResults([]); // ✅ Clear results

    setPurchaseOrder((prev) => ({
      ...prev,
      supplierCode: supplier.name, // ✅ Store carrier selection in order
    }));

    setSelectedSupplier({
      leadTime: supplier.leadTime || "N/A",
      paymentTerm: supplier.paymentTerm || "N/A",
    });
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // FETCH DROPDOWN OPTIONS
  // ─────────────────────────────────────────────────────────────────────────────
  // useEffect(() => {
  //   const fetchDropdowns = async () => {
  //     try {
  //       const [carriersRes, buyersRes, sellersRes] = await Promise.all([
  //         axios.get(`http://localhost:8080/api/carriers/office/${officeCode}`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }),
  //         axios.get(`http://localhost:8080/api/buyers/office/${officeCode}`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }),
  //         axios.get(`http://localhost:8080/api/suppliers/office/${officeCode}`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }),
  //       ]);
  //       console.log("Carrier Data" + carriersRes.data);
  //       // setCarriers(carriersRes.data);
  //       // setBuyers(buyersRes.data);
  //       // setSellers(sellersRes.data);
  //       // setStatus(status.data);
  //     } catch (error) {
  //       console.error("Error fetching dropdown data:", error);
  //     }
  //   };

  //   fetchDropdowns();
  // }, [token]);

  // ─────────────────────────────────────────────────────────────────────────────
  // HANDLING DELIVERY METHOD
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  //  HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPurchaseOrder((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // SUBMIT HANDLER
  // ─────────────────────────────────────────────────────────────────────────────

  /******************* Handle 1 item at a time and no line items *****************************/
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const response = await axios.post(
  //       "http://localhost:8080/api/orders",
  //       purchaseOrder,
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );
  //     console.log("Purchase Order created:", response.data);
  //     navigate("/dashboard/orders");
  //   } catch (error) {
  //     console.error("Error creating Purchase Order:", error);
  //     // alert("Failed to create Purchase Order");
  //     alert(JSON.stringify(purchaseOrder, null, 2));
  //   }
  // };

  /************************ Handle Several items ***************************/
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    // ✅ Collect missing fields
    let validationErrors = {};

    if (!purchaseOrder.orderNumber.trim()) {
      validationErrors.orderNumber = "Order Number is required.";
    }
    if (!purchaseOrder.shipFromLocation.trim()) {
      validationErrors.shipFromLocation = "Ship From Location is required.";
    }
    if (!purchaseOrder.shipToLocation.trim()) {
      validationErrors.shipToLocation = "Ship To Location is required.";
    }
    if (!purchaseOrder.orderDatetime) {
      validationErrors.orderDatetime = "Order Date is required.";
    }
    if (!purchaseOrder.expectedDeliveryDatetime) {
      validationErrors.expectedDeliveryDatetime = "Delivery Date is required.";
    }
    if (!purchaseOrder.orderTotalAmount) {
      validationErrors.orderTotalAmount = "Total Amount is required.";
    }

    if (!purchaseOrder.deliveryMethod) {
      validationErrors.deliveryMethod = "Delivery Method is required.";
    }

    // ✅ Validate items (if required)
    if (items.length === 0) {
      validationErrors.items = "At least one line item is required.";
    }

    // ✅ Validate each item inside `items`
    items.forEach((item, index) => {
      if (!item.itemQuantity || item.itemQuantity < 1) {
        validationErrors[`itemQuantity-${index}`] =
          "Quantity must be at least 1.";
      }
    });

    // ✅ If errors exist, prevent submission
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      alert("Please fill in all required fields before submitting.");
      return;
    }

    try {
      // ✅ Step 1: Create the PO and retrieve the `orderId`
      const poResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders`,
        purchaseOrder,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
          },
        }
      );
      console.log("Purchase Order created:", poResponse.data);

      // ✅ Extract the created `orderId`
      const orderId = poResponse.data.id; // Ensure `id` exists in API response

      // ✅ Step 2: Create Line Items for the Order
      const lineItemRequests = items.map((item) => ({
        sku: item.sku,
        itemName: item.name,
        itemQuantity: item.itemQuantity, // Default quantity (update as needed)
        itemPrice: item.sellingPrice, // Use selling price as price
        orderId: orderId, // ✅ Associate line item with created PO
      }));

      // ✅ Step 3: Attempt to post all line items
      try {
        await Promise.all(
          lineItemRequests.map((lineItem) =>
            axios.post(
              `${process.env.REACT_APP_API_BASE_URL}/api/order-line-items`,
              lineItem,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                  "Office-Code": officeCode,
                },
              }
            )
          )
        );

        console.log("Line items created successfully");

        // ✅ Redirect after full success
        alert("Order Succesfully Created.");
        navigate("/dashboard/orders");
      } catch (lineItemError) {
        console.error("Error creating Line Items:", lineItemError);

        // ❌ Rollback: If line item creation fails, delete the PO
        await axios.delete(
          `${process.env.REACT_APP_API_BASE_URL}/api/orders/${orderId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        console.log(`Rolled back PO ${orderId} due to line item failure`);
        alert("Failed to create Line Items. Order has been rolled back.");
      }
    } catch (error) {
      console.error("Error creating Purchase Order:", error);
      alert("Failed to create Purchase Order.");
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 5) RENDER FORM
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="bg-white p-4 rounded-md shadow-md">
      <h1 className="text-xl font-bold mb-4">Create New Purchase Order</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block font-medium">Order Number*</label>
            <input
              type="text"
              name="orderNumber"
              value={purchaseOrder.orderNumber}
              onChange={handleChange}
              className="border p-2 w-full"
            />
            {errors.orderNumber && (
              <p className="text-red-500 text-sm">{errors.orderNumber}</p>
            )}
          </div>

          {/* Carrier Search */}
          {/* <div>
            <label className="block font-medium">Search for Carrier</label>
            <input
              type="text"
              value={carriers}
              onChange={handleInputCarrierChange}
              placeholder="Type to search..."
              className="border p-2 w-full"
            />
            <ul className="border rounded-md mt-1 bg-white max-h-40 overflow-auto">
              {carrierResults.map((carrier) => (
                <li
                  key={carrier.id}
                  className="p-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSelectCarrier(carrier)}
                >
                  {carrier.name}
                </li>
              ))}
            </ul>
          </div> */}
        </div>

        {/** ////////////////////  BEGIN HANDLE ONE ITEM AT A TIME /////////////////////////// */}
        {/* <div className="mt-6">
          <h2 className="text-lg font-semibold border-b-2 border-gray-300 pb-1">
            Inventory Information
          </h2>
          <div className="grid grid-cols-2 gap-4"> */}
        {/* Inventory Search */}
        {/* <div>
              <label className="block font-medium">Line Items</label>
              <input
                type="text"
                value={item}
                onChange={handleInputItemChange}
                placeholder="Type to search..."
                className="border p-2 w-full"
              />
              <ul className="border rounded-md mt-1 bg-white max-h-40 overflow-auto">
                {itemResults.map((product) => (
                  <li
                    key={product.id}
                    className="p-2 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSelectProduct(product)}
                  >
                    {product.name}
                  </li>
                ))}
              </ul>
            </div> */}

        {/* Item SKU */}
        {/* <div>
              <label className="block font-medium">SKU</label>
              <input
                type="text"
                name="itemSku"
                value={selectedItem.sku}
                // onChange={handleSelectProduct}
                readOnly // ✅ Prevent user from editing
                // className="border p-2 w-full"
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div> */}

        {/* Item Reorder Level */}
        {/* <div>
              <label className="block font-medium">Reorder Level</label>
              <input
                type="text"
                name="itemReorderLevel"
                value={selectedItem.reorderLevel}
                // onChange={handleChange}
                readOnly // ✅ Prevent user from editing
                // className="border p-2 w-full"
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div> */}

        {/* Item Cost Price */}
        {/* <div>
              <label className="block font-medium">Cost Price</label>
              <input
                type="text"
                name="itemCostPrice"
                value={selectedItem.costPrice}
                // onChange={handleChange}
                readOnly // ✅ Prevent user from editing
                // className="border p-2 w-full"
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div> */}

        {/* Item Selling Price */}
        {/* <div>
              <label className="block font-medium">Selling Price</label>
              <input
                type="text"
                name="itemSellingPrice"
                value={selectedItem.sellingPrice}
                // onChange={handleChange}
                readOnly // ✅ Prevent user from editing
                // className="border p-2 w-full"
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div> */}
        {/* </div>
        </div> */}
        {/** ////////////////////  END HANDLE ONE ITEM AT A TIME /////////////////////////// */}

        {/** ////////////////////  BEGIN HANDLE **MANY** ITEM AT A TIME /////////////////////////// */}
        {/* Inventory Information Section */}
        <div className="mt-6">
          <h2 className="text-lg font-semibold border-b-2 border-gray-300 pb-1">
            Inventory Information
          </h2>

          {items.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-2 gap-4 mt-4 border-b pb-4"
            >
              {/* Inventory Search */}
              <div>
                <label className="block font-medium">
                  Line Item {index + 1}
                </label>
                <input
                  type="text"
                  value={item.name}
                  onChange={(e) => handleInputItemChange(e, index)}
                  placeholder="Type to search..."
                  className="border p-2 w-full"
                />
                <ul className="border rounded-md mt-1 bg-white max-h-40 overflow-auto">
                  {itemResults.map((product) => (
                    <li
                      key={product.id}
                      className="p-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => handleSelectProduct(product, index)}
                    >
                      {product.name}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Item SKU */}
              <div>
                <label className="block font-medium">SKU</label>
                <input
                  type="text"
                  name="itemSku"
                  value={item.sku}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </div>

              {/* Item Reorder Level */}
              <div>
                <label className="block font-medium">Reorder Level</label>
                <input
                  type="text"
                  name="itemReorderLevel"
                  value={item.reorderLevel}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </div>

              {/* Item Cost Price */}
              <div>
                <label className="block font-medium">Cost Price</label>
                <input
                  type="text"
                  name="itemCostPrice"
                  value={item.costPrice}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </div>

              {/* Item Selling Price */}
              <div>
                <label className="block font-medium">Selling Price</label>
                <input
                  type="text"
                  name="itemSellingPrice"
                  value={item.sellingPrice}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </div>

              {/* Item Quantity (No Negatives Allowed) */}
              <div>
                <label className="block font-medium">Quantity*</label>
                <input
                  type="number"
                  name="itemQuantity"
                  value={item.itemQuantity}
                  min="1"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d+$/.test(value) && parseInt(value, 10) >= 1)
                    ) {
                      const newItems = [...items];
                      newItems[index].itemQuantity =
                        value === "" ? "" : parseInt(value, 10);
                      setItems(newItems);
                    }
                  }}
                  className="border p-2 w-full"
                />
                {errors[`itemQuantity-${index}`] && (
                  <p className="text-red-500 text-sm">
                    {errors[`itemQuantity-${index}`]}
                  </p>
                )}
              </div>

              {/* Remove Item Button */}
              <div className="col-span-2 text-right">
                <button
                  type="button"
                  onClick={() => handleRemoveItem(index)}
                  className="text-red-500 underline text-sm"
                >
                  Remove Item
                </button>
              </div>
            </div>
          ))}

          {/* Add Item Button */}
          <div className="mt-4">
            <button
              type="button"
              onClick={handleAddItem}
              className="bg-blue-500 text-white px-4 py-2 rounded-md"
            >
              + Add Item
            </button>
          </div>
        </div>
        {/** ////////////////////  END HANDLE **MANY** ITEM AT A TIME /////////////////////////// */}

        {/* Supplier Information Section */}
        <div className="mt-6">
          <h2 className="text-lg font-semibold border-b-2 border-gray-300 pb-1">
            Supplier Information
          </h2>
          <div className="grid grid-cols-2 gap-4">
            {/* Supplier Search */}
            <div>
              <label className="block font-medium">Supplier</label>
              <input
                type="text"
                value={supplier}
                onChange={handleInputSupplierChange}
                placeholder="Type to search..."
                className="border p-2 w-full"
              />
              <ul className="border rounded-md mt-1 bg-white max-h-40 overflow-auto">
                {supplierResult.map((supplier) => (
                  <li
                    key={supplier.id}
                    className="p-2 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSelectSupplier(supplier)}
                  >
                    {supplier.name}
                  </li>
                ))}
              </ul>
            </div>

            {/* Supplier Lead Time */}
            <div>
              <label className="block font-medium">Lead Time</label>
              <input
                type="text"
                name="supplierLeadTime"
                value={selectedSupplier.leadTime}
                // onChange={handleSelectSupplier}
                readOnly // ✅ Prevent user from editing
                // className="border p-2 w-full"
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div>

            {/* Supplier PaymentTerm */}
            <div>
              <label className="block font-medium">Payment Term</label>
              <input
                type="email"
                name="supplierPaymentTerm"
                value={selectedSupplier.paymentTerm}
                // onChange={handleChange}
                readOnly // ✅ Prevent user from editing
                // className="border p-2 w-full"
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div>
          </div>
        </div>

        {/* Buyer Information Section */}
        <div className="mt-6">
          <h2 className="text-lg font-semibold border-b-2 border-gray-300 pb-1">
            Buyer Information
          </h2>

          <div className="grid grid-cols-2 gap-4 mt-4">
            {/* Buyer Dropdown */}
            <div>
              <label className="block font-medium">Search For Buyer</label>
              <input
                type="text"
                value={buyer}
                onChange={handleInputBuyerChange}
                placeholder="Type to search..."
                className="border p-2 w-full"
              />
              <ul className="border rounded-md mt-1 bg-white max-h-40 overflow-auto">
                {buyerResults.map((buyer) => (
                  <li
                    key={buyer.id}
                    className="p-2 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSelectBuyer(buyer)}
                  >
                    {buyer.name}
                  </li>
                ))}
              </ul>
            </div>

            {/* Buyer Contact Name */}
            <div>
              <label className="block font-medium">Buyer Contact Name</label>
              <input
                type="text"
                name="buyerContactName"
                value={selectedBuyer.contactName}
                readOnly // ✅ Prevent user from editing
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div>

            {/* Buyer Email */}
            <div>
              <label className="block font-medium">Buyer Email</label>
              <input
                type="email"
                name="buyerEmail"
                value={selectedBuyer.email}
                readOnly // ✅ Prevent user from editing
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div>

            {/* Buyer Phone Number */}
            <div>
              <label className="block font-medium">Buyer Phone</label>
              <input
                type="tel"
                name="buyerPhone"
                value={selectedBuyer.phone}
                readOnly // ✅ Prevent user from editing
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div>

            {/* Buyer Address (Full Width) */}
            <div className="col-span-2">
              <label className="block font-medium">Buyer Address</label>
              <input
                type="text"
                name="buyerAddress"
                value={selectedBuyer.address}
                readOnly // ✅ Prevent user from editing
                className="border p-2 w-full bg-gray-100 cursor-not-allowed"
              />
            </div>
          </div>
        </div>

        {/* Delivery Method Selection */}
        <div className="mt-6">
          <h2 className="text-lg font-semibold border-b-2 border-gray-300 pb-1">
            Delivery Method
          </h2>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <div className="col-span-1">
              <label className="block text-gray-700 text-sm font-medium mb-1">
                Select Delivery Method
              </label>
              <select
                name="deliveryMethod"
                value={purchaseOrder.deliveryMethod}
                onChange={handleChange} // ✅ No need for a separate function
                className={`border p-2 w-full ${
                  errors.deliveryMethod ? "border-red-500" : ""
                }`}
              >
                <option value="">-- Select Delivery Method --</option>
                <option value="Delivery">Delivery</option>
                <option value="Pick-Up">Pick-Up</option>
              </select>

              {/* Display validation error if the field is required */}
              {errors.deliveryMethod && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.deliveryMethod}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Location Inputs */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block font-medium">Ship From</label>
            <input
              type="text"
              name="shipFromLocation"
              value={purchaseOrder.shipFromLocation}
              onChange={handleChange}
              className="border p-2 w-full"
            />
          </div>

          <div>
            <label className="block font-medium">Ship To</label>
            <input
              type="text"
              name="shipToLocation"
              value={purchaseOrder.shipToLocation}
              onChange={handleChange}
              className="border p-2 w-full"
            />
          </div>
        </div>

        {/* Dates */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block font-medium">Order Date</label>
            <input
              type="datetime-local"
              name="orderDatetime"
              value={purchaseOrder.orderDatetime}
              onChange={handleChange}
              className="border p-2 w-full"
            />
          </div>
          <div>
            {/* ✅ Dynamically change label based on selected delivery method */}
            <label className="block font-medium">
              {purchaseOrder.deliveryMethod === "Pick-Up"
                ? "Pick-Up Date"
                : "Expected Delivery Date"}
            </label>
            <input
              type="datetime-local"
              name="expectedDeliveryDatetime"
              value={purchaseOrder.expectedDeliveryDatetime}
              onChange={handleChange}
              className="border p-2 w-full"
            />
          </div>
        </div>

        {/* Status & Total */}
        <div className="grid grid-cols-2 gap-4">
          {/* <div>
            <label className="block font-medium">Status</label>
            <select
              name="statusId"
              value={purchaseOrder.statusId}
              onChange={handleChange}
              className="border p-2 w-full"
            >
              <option value="">-- Select Status --</option>
              {status.map((status) => (
                <option key={status.id} value={status.id}>
                  {status.status}
                </option>
              ))}
            </select>
          </div> */}

          <div>
            <label className="block font-medium">Total*</label>
            <input
              type="text" // ✅ Change input type to "text" to handle restrictions manually
              name="orderTotalAmount"
              value={purchaseOrder.orderTotalAmount}
              onChange={(e) => {
                let value = e.target.value;

                if (value === "") {
                  // ✅ Allow clearing the field
                  setPurchaseOrder((prev) => ({
                    ...prev,
                    orderTotalAmount: "",
                  }));
                } else if (/^\d*\.?\d{0,2}$/.test(value)) {
                  // ✅ Only allow valid numbers with up to 2 decimal places
                  setPurchaseOrder((prev) => ({
                    ...prev,
                    orderTotalAmount: value,
                  }));
                }
              }}
              className={`border p-2 w-full ${
                errors.orderTotalAmount ? "border-red-500" : ""
              }`}
              inputMode="decimal" // ✅ Helps mobile users enter numbers easily
            />

            {errors.orderTotalAmount && (
              <p className="text-red-500 text-sm mt-1">
                {errors.orderTotalAmount}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col items-end ml-auto">
            <HeaderActions buttons={button} />
          </div>

        {/* <button
          type="submit"
          className="bg-green-500 text-white px-4 py-2 rounded mt-4"
        >
          Submit Order
        </button> */}
      </form>
    </div>
  );
};

export default CreatePO;
